/**
 * Structure of the user terms ("Brukervilkår for Zuprize"), from Brukervilkar_Zuprize_Versjon21.docx.
 *
 * Generated from the client's document; every id is a translation key whose
 * Norwegian text is the document's, verbatim. Rendered by
 * _marketingPage/LegalDocument.js. To change the wording, change the
 * translation, not this file; to change the structure, regenerate it.
 */
const userTermsDocument = {
  header: {
    eyebrow: null,
    heading: 'UserTermsPage.heroHeading',
    lede: [
      'UserTermsPage.heroLede1'
    ],
    lastUpdated: 'UserTermsPage.lastUpdated'
  },
  sections: [
    {
      id: 'om-zuprize',
      heading: 'UserTermsPage.s1Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s1b1'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s1b2'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s1b3'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s1b4'
        }
      ]
    },
    {
      id: 'hvem-kan-bruke-zuprize',
      heading: 'UserTermsPage.s2Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s2b1'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s2b2'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s2b3'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s2b4'
        }
      ]
    },
    {
      id: 'hva-som-kan-selges',
      heading: 'UserTermsPage.s3Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s3b1'
        }
      ]
    },
    {
      id: 'annonsen-og-ditt-ansvar-som-selger',
      heading: 'UserTermsPage.s4Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s4b1'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s4b2'
        }
      ]
    },
    {
      id: 'slik-ser-du-hvem-du-kjoper-fra',
      heading: 'UserTermsPage.s5Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s5b1'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s5b2'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s5b3'
        }
      ]
    },
    {
      id: 'kjopsavtalen',
      heading: 'UserTermsPage.s6Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s6b1'
        }
      ]
    },
    {
      id: 'pris-provisjon-og-gebyrer',
      heading: 'UserTermsPage.s7Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s7b1'
        }
      ]
    },
    {
      id: 'betaling',
      heading: 'UserTermsPage.s8Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s8b1'
        }
      ]
    },
    {
      id: 'frakt-og-levering',
      heading: 'UserTermsPage.s9Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s9b1'
        }
      ]
    },
    {
      id: 'angrerett',
      heading: 'UserTermsPage.s10Heading',
      blocks: [
        {
          type: 'sub',
          id: 'UserTermsPage.s10b1'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s10b2'
        },
        {
          type: 'sub',
          id: 'UserTermsPage.s10b3'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s10b4'
        },
        {
          type: 'list',
          items: [
            'UserTermsPage.s10b5i1',
            'UserTermsPage.s10b5i2',
            'UserTermsPage.s10b5i3',
            'UserTermsPage.s10b5i4',
            'UserTermsPage.s10b5i5'
          ]
        }
      ]
    },
    {
      id: 'feil-og-mangler-reklamasjon',
      heading: 'UserTermsPage.s11Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s11b1'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s11b2'
        }
      ]
    },
    {
      id: 'kjoperbeskyttelse-og-utbetaling-til-selger',
      heading: 'UserTermsPage.s12Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s12b1'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s12b2'
        },
        {
          type: 'list',
          items: [
            'UserTermsPage.s12b3i1',
            'UserTermsPage.s12b3i2',
            'UserTermsPage.s12b3i3',
            'UserTermsPage.s12b3i4'
          ]
        },
        {
          type: 'p',
          id: 'UserTermsPage.s12b4'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s12b5'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s12b6'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s12b7'
        }
      ]
    },
    {
      id: 'skatt-og-avgift',
      heading: 'UserTermsPage.s13Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s13b1'
        },
        {
          type: 'list',
          items: [
            'UserTermsPage.s13b2i1',
            'UserTermsPage.s13b2i2'
          ]
        },
        {
          type: 'p',
          id: 'UserTermsPage.s13b3'
        }
      ]
    },
    {
      id: 'dette-er-ikke-tillatt',
      heading: 'UserTermsPage.s14Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s14b1'
        }
      ]
    },
    {
      id: 'rangering-og-synlighet',
      heading: 'UserTermsPage.s15Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s15b1'
        }
      ]
    },
    {
      id: 'vurderinger',
      heading: 'UserTermsPage.s16Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s16b1'
        }
      ]
    },
    {
      id: 'personopplysninger',
      heading: 'UserTermsPage.s17Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s17b1'
        }
      ]
    },
    {
      id: 'kontroll-av-annonser-varsling-og-stenging-av-konto',
      heading: 'UserTermsPage.s18Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s18b1'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s18b2'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s18b3'
        }
      ]
    },
    {
      id: 'zuprizes-ansvar',
      heading: 'UserTermsPage.s19Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s19b1'
        }
      ]
    },
    {
      id: 'force-majeure',
      heading: 'UserTermsPage.s20Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s20b1'
        }
      ]
    },
    {
      id: 'selgers-ansvar-overfor-zuprize',
      heading: 'UserTermsPage.s21Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s21b1'
        }
      ]
    },
    {
      id: 'endringer-i-vilkarene',
      heading: 'UserTermsPage.s22Heading',
      blocks: [
        {
          type: 'p',
          id: 'UserTermsPage.s22b1'
        }
      ]
    },
    {
      id: 'uenighet-klage-og-tvistelosning',
      heading: 'UserTermsPage.s23Heading',
      blocks: [
        {
          type: 'sub',
          id: 'UserTermsPage.s23b1'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s23b2'
        },
        {
          type: 'sub',
          id: 'UserTermsPage.s23b3'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s23b4'
        },
        {
          type: 'sub',
          id: 'UserTermsPage.s23b5'
        },
        {
          type: 'list',
          items: [
            'UserTermsPage.s23b6i1',
            'UserTermsPage.s23b6i2'
          ]
        },
        {
          type: 'sub',
          id: 'UserTermsPage.s23b7'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s23b8'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s23b9'
        },
        {
          type: 'sub',
          id: 'UserTermsPage.s23b10'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s23b11'
        },
        {
          type: 'sub',
          id: 'UserTermsPage.s23b12'
        },
        {
          type: 'p',
          id: 'UserTermsPage.s23b13'
        }
      ]
    },
    {
      id: 'kontaktinformasjon',
      heading: 'UserTermsPage.s24Heading',
      blocks: [
        {
          type: 'lines',
          lines: [
            'UserTermsPage.s24b1l1',
            'UserTermsPage.s24b1l2',
            'UserTermsPage.s24b1l3',
            'UserTermsPage.s24b1l4'
          ]
        }
      ]
    }
  ],
  summary: {
    heading: 'UserTermsPage.summaryHeading',
    items: [
      'UserTermsPage.summaryI1',
      'UserTermsPage.summaryI2',
      'UserTermsPage.summaryI3',
      'UserTermsPage.summaryI4',
      'UserTermsPage.summaryI5'
    ]
  }
};

export default userTermsDocument;
